<template>
  <div
    class="style1 align-left"
    :class="{
      err: fieldObj.dirty && fieldObj.invalid
    }"
  >
    <a-checkbox
      @change="handleChange"
      :disabled="fieldObj.disabled"
      v-model="fieldObj.isSelected"
    >
      <span v-for="u in fieldObj.privacyPolicyTitle" :key="u">{{ u }}</span>
      <a
        class="u-policy-text"
        target="_blank"
        :href="fieldObj.privacyPolicyUrl"
        >{{ fieldObj.privacyPolicyUrlTitle }}</a
      >
    </a-checkbox>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>

<script>
import policyMixin from "../../field/new-fields/policy";
export default {
  name: "sk-policy",
  mixins: [policyMixin]
};
</script>
<style>
.align-left {
  text-align: left;
}
</style>
